import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyAiELnhBw6Tg3gdNsl8oulMAhDuOYUFsfk",
  authDomain: "mindly-95916.firebaseapp.com",
  projectId: "mindly-95916",
  storageBucket: "mindly-95916.firebasestorage.app",
  messagingSenderId: "202749844490",
  appId: "1:202749844490:web:66fe04b5e838399d7fd3f3"
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
